/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import server from '../_api/backend';
import * as toast from '../_store/slice/toast';
import { AsideMyinfo } from '../_layout/aside-myinfo';

export function Signout(props: RouteComponentProps) {
  const [username, setUserName] = useState<any>();
  const [name, setName] = useState<any>();
  const [password, setPassword] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    getUserInfo();
  }, []);

  // 취소 버튼 클릭 시
  const onClickCancel = () => {
    props.history.go(-1);
  };

  // 회원정보 조회 API 호출
  const getUserInfo = async () => {
    await server
      .getUserOwn()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setUserName(payload.username);
          setName(payload.name);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 회원탈퇴 API 호출
  const onClickSignout = async () => {
    await server
      .deleteUserOwn({ password })
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '회원탈퇴가 완료되었습니다.' }));
          window.localStorage.removeItem('token');
          window.localStorage.removeItem('username');
          window.localStorage.removeItem('loginTime');
          window.localStorage.removeItem('name');
          window.localStorage.removeItem('college');
          window.localStorage.removeItem('department');
          window.localStorage.removeItem('email');
          window.localStorage.removeItem('part');
          props.history.replace('/');
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // Signout 리턴값
  return (
    <main className="sub wrapper">
      <AsideMyinfo />
      <div className="content">
        <div className="breadscrumb">
          <a href="1">Home</a>
          <a href="2">
            <span> 회원탈퇴</span>
          </a>
        </div>
        <div className="title">
          <h2>회원탈퇴</h2>
          <p>회원님의 계정을 탈퇴하는 페이지입니다.</p>
        </div>
        <section>
          <ul className="inputs">
            <li>
              <span>이름</span>
              <input type="text" readOnly value={name || ''} />
            </li>
            <li>
              <span>아이디(ID)</span>
              <input type="text" readOnly value={username || ''} />
            </li>
            <li>
              <span className="required">비밀번호</span>
              <input
                type="password"
                defaultValue={password || ''}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
              />
            </li>
            <li>
              <small>
                ※ 구민사 회원을 탈퇴하시면 로그인을 포함한 주문내역조회, 견본도서신청 등을 진행하실
                수 없으며 회원개인정보는 복구되지 않습니다.
              </small>
            </li>
          </ul>
          <div className="buttons">
            <button className="btn-sub" onClick={onClickCancel}>
              취소
            </button>
            <button className="btn-main" onClick={onClickSignout}>
              회원탈퇴
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
